import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-switch-wrap" }

import "@vuepic/vue-datepicker/dist/main.css";
import {computed, onMounted, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ui-switch',
  props: {
  /**
   * Значение
   */
  modelValue: {
    type: Boolean,
  },
  /**
   * Текс
   */
  label: {
    type: String,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;



/**
 * События
 */


/**
 * Внутреннее значение
 */
const innerValue = ref<Boolean>();

/**
 * Значение
 */
const value = computed({
  get: () => {
    return props.modelValue == null ? innerValue.value : props.modelValue;
  },
  set: (value) => {
    emit("update:modelValue", value);
    innerValue.value = value;
  },
});

onMounted(async () => {
  innerValue.value = props.modelValue;
});

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_switch, {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      label: __props.label,
      class: "ui-switch",
      color: "var(--main-color)",
      "hide-details": "",
      inset: ""
    }, null, 8, ["modelValue", "label"])
  ]))
}
}

})